import { Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';

const ResetSuccess = () => {
  return (
    <>
      <img
        src={i18n.t(
          'ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess'
        )}
        alt="horizontal logo of free style libre"
        id="ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess"
        style={{
          marginTop: '40px',
          height: '105px',
          objectFit: 'contain',
        }}
      />

      <Text
        nativeID="ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText"
        fontWeight="$h2.medium"
        fontSize="$h2.medium"
        color="$text.100"
        display="flex"
        flexDirection="column"
        textAlign="center"
      >
        {i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText')}
      </Text>

      <Text
        nativeID="ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText"
        color="$text.80"
        textAlign="center"
      >
        {i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText')}
      </Text>
      <Text
        nativeID="ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.bodyText"
        color="$text.80"
        textAlign="center"
      >
        {i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.bodyText')}
      </Text>
    </>
  );
};

export { ResetSuccess };
